angular.module('cian.offerTypeBrowser', ['cian.ui.button', 'cian.filter'])
.config(["$interpolateProvider", function($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}]);



// WEBPACK FOOTER //
// ./src/components/offer-type-browser/src/scripts/cian.offer-type-browser.js